export const $WishlistSidebarModuleName = "wishlistSidebar";

export interface TWishlistSidebarState {
    visible: boolean;
    currentListId?: string;
}
